import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-full-width-image-dialog',
  templateUrl: './full-width-image-dialog.component.html',
  styleUrls: ['./full-width-image-dialog.component.css']
})
export class FullWidthImageDialogComponent {
  imageUrl: string;

  constructor(public activeModal: NgbActiveModal) {}
}
